var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { MessageByTypeEnum } from '../Models';
import { getSystemMessage } from '../Utils';
var Notice = function (props) {
    var from = MessageByTypeEnum[props.message.from];
    var getSystemMessageNotice = function (message) {
        if (message &&
            message.from === "System" &&
            (!message.message ||
                message.system_message_type === "CHAT_SESSION_CLOSED"))
            return getSystemMessage(message.system_message_type);
        return message.message;
    };
    return (_jsx("div", __assign({ className: "chat__messages-notice" }, { children: getSystemMessageNotice(props.message) })));
};
export default Notice;
